import React from "react";
import { formatCurrency } from "../../../shared/utility";

export default function PurchaseOrderSummaryPanel({
  lineSummary,
  compact = false,
}: any) {
  const summary = lineSummary ?? {
    lineCount: 0,
    totalQty: 0,
    totalCartons: 0,
    subtotal: null,
    taxTotal: null,
    grandTotal: null,
  };

  const pricingRows = (
    <>
      <div className="flex justify-between gap-4">
        <dt className="text-[#64748B]">Subtotal</dt>
        <dd className="font-semibold tabular-nums text-[#0F172A]">
          {summary.subtotal != null ? formatCurrency(summary.subtotal) : "—"}
        </dd>
      </div>
      <div className="flex justify-between gap-4">
        <dt className="text-[#64748B]">Tax</dt>
        <dd className="font-semibold tabular-nums text-[#0F172A]">
          {summary.taxTotal != null ? formatCurrency(summary.taxTotal) : "—"}
        </dd>
      </div>
      <div className="flex justify-between gap-4 border-t border-[#E2E8F0] pt-2">
        <dt className="font-medium text-[#0F172A]">Grand total</dt>
        <dd className="text-base font-bold tabular-nums text-[#0F172A]">
          {summary.grandTotal != null
            ? formatCurrency(summary.grandTotal)
            : "—"}
        </dd>
      </div>
    </>
  );

  if (compact) {
    return (
      <div className="flex h-full flex-col gap-3">
        <section className="rounded-2xl border border-[#E2E8F0] bg-white p-4 shadow-sm">
          <h2 className="text-sm font-semibold text-[#0F172A]">PO summary</h2>
          <dl className="mt-3 space-y-2 text-sm">
            <div className="flex justify-between gap-4">
              <dt className="text-[#64748B]">Line items</dt>
              <dd className="font-semibold tabular-nums text-[#0F172A]">
                {summary.lineCount}
              </dd>
            </div>
            <div className="flex justify-between gap-4">
              <dt className="text-[#64748B]">Total ordered qty</dt>
              <dd className="font-semibold tabular-nums text-[#0F172A]">
                {summary.totalQty.toLocaleString("en-US")}
              </dd>
            </div>
            {pricingRows}
          </dl>
        </section>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <section className="rounded-2xl border border-[#E2E8F0] bg-white p-5 shadow-sm">
        <h2 className="text-base font-semibold text-[#0F172A]">PO summary</h2>
        <p className="mt-1 text-sm text-[#64748B]">
          Review expected quantity and pricing before saving.
        </p>
        <dl className="mt-5 space-y-3 text-sm">
          <div className="flex justify-between gap-4">
            <dt className="text-[#64748B]">Line items</dt>
            <dd className="font-semibold tabular-nums text-[#0F172A]">
              {summary.lineCount}
            </dd>
          </div>
          <div className="flex justify-between gap-4">
            <dt className="text-[#64748B]">Total ordered qty</dt>
            <dd className="font-semibold tabular-nums text-[#0F172A]">
              {summary.totalQty.toLocaleString("en-US")}
            </dd>
          </div>
          {pricingRows}
        </dl>
      </section>
    </div>
  );
}
